import { LandingNav } from '../components/landing/LandingNav';
import { LandingHero } from '../components/landing/LandingHero';
import { LandingAbout } from '../components/landing/LandingAbout';
import { LandingServices } from '../components/landing/LandingServices';
import { LandingReviews } from '../components/landing/LandingReviews';
import { LandingAdvantage } from '../components/landing/LandingAdvantage';
import { LandingFooter } from '../components/landing/LandingFooter';
import { PageTransition } from '../components/common/PageTransition';
import { FadeIn } from '../components/common/FadeIn';
import { Helmet } from 'react-helmet-async';

export const LandingPage = () => {
    return (
        <PageTransition>
            <div className="bg-landing-background-light dark:bg-landing-background-dark text-slate-900 dark:text-slate-100 font-landing-sans transition-colors duration-300">
                <Helmet>
                    <title>Pacces Advogados | Advocacia Imobiliária e Empresarial em São Paulo</title>
                    <meta name="description" content="Escritório de advocacia especializado em Direito Imobiliário, Empresarial e Cível. Atendimento personalizado e soluções jurídicas estratégicas em São Paulo." />
                    <link rel="canonical" href="https://paccesadvogados.com.br/" />

                    <meta property="og:type" content="website" />
                    <meta property="og:site_name" content="Pacces Advogados" />
                    <meta property="og:locale" content="pt_BR" />
                    <meta property="og:url" content="https://paccesadvogados.com.br/" />
                    <meta property="og:title" content="Pacces Advogados | Advocacia Imobiliária e Empresarial em São Paulo" />
                    <meta property="og:description" content="Escritório de advocacia especializado em Direito Imobiliário, Empresarial e Cível. Soluções jurídicas estratégicas com atendimento personalizado em São Paulo." />
                    <meta property="og:image" content="https://paccesadvogados.com.br/og-image.png" />
                    <meta property="og:image:width" content="1080" />
                    <meta property="og:image:height" content="1080" />
                    <meta property="og:image:alt" content="Pacces Advogados — Excelência e Estratégia Jurídica" />
                    <meta property="og:image:type" content="image/png" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:site" content="@paccesadvogados" />
                    <meta name="twitter:url" content="https://paccesadvogados.com.br/" />
                    <meta name="twitter:title" content="Pacces Advogados | Advocacia Imobiliária e Empresarial em São Paulo" />
                    <meta name="twitter:description" content="Escritório de advocacia especializado em Direito Imobiliário, Empresarial e Cível. Atendimento personalizado em São Paulo." />
                    <meta name="twitter:image" content="https://paccesadvogados.com.br/og-image.png" />
                </Helmet>
                <LandingNav />
                <LandingHero />
                <FadeIn>
                    <LandingAbout />
                </FadeIn>
                <FadeIn delay={0.05}>
                    <div id="services">
                        <LandingServices />
                    </div>
                </FadeIn>
                <FadeIn>
                    <LandingAdvantage />
                </FadeIn>
                <FadeIn>
                    <LandingReviews />
                </FadeIn>
                <LandingFooter />
            </div>
        </PageTransition>
    );
};
